import { Component } from '@angular/core';

@Component({
  selector: 'app-login-left-panel',
  templateUrl: './login-left-panel.component.html',
  styleUrls: ['./login-left-panel.component.css']
})
export class LoginLeftPanelComponent {

}
